import React, { useCallback } from "react";
import { Link, } from '~/native-ui/Link';
import { overrideDefaultComponents } from '~/native-ui';

import { connect } from "~/redux/connect";
import { smartGoto, pushWithAbsoluteLinks } from '~/actions/navigation_actions';

export const SmartGotoLink = connect(null, mapDispatchToProps)(
    ({ title, goToUrl, pushUrl, shouldPush, ...props }) => {
        const openInNewTab = !!props.target && props.target !== "_self";

        const onClick = useCallback((e) => {
            // if onClick is defined, we don't want to override it
            if (props.onClick)  return props.onClick(e);

            const push = shouldPush ? pushUrl : goToUrl;

            e.preventDefault();
            if (props.href === '/') {
                push(props.href, { openInNewTab });
                return 
            }

            const path = new URL(props.href, window.location.origin);
            const href = path.pathname !== '/'
                ? props.href
                : "/admin" + window.location.pathname + path.search + path.hash;

            push(href, { openInNewTab });
        }, [props.target, props.onClick, goToUrl, props.href]);
    
    
        return <Link {...props} onClick={onClick} />
    }
);

function mapDispatchToProps (dispatch) {
    return ({
        goToUrl: (uri, options) => {
            if (!uri) return;
            return dispatch(smartGoto(uri, {}, options));
        },
        pushUrl: (uri, options) => {
            if (!uri) return;
            return dispatch(pushWithAbsoluteLinks(uri, {},  options));
        },
    })
}

export { SmartGotoLink as Link }

overrideDefaultComponents({
    a: SmartGotoLink
})